import { TableCell, TableRow, Typography } from '@mui/material';
import { InvoiceInfoDto } from '@sr/dto';
import { LinkToInvoice } from 'entities/client-invoices-list/ui/link-to-invoice';
import { InvoiceStatusSpan } from 'entities/invoice/status-span/status-span';
import { useLeadInvoices } from 'entities/lead/leads.hook';
import { GridLayout } from 'shared/ui/grid-layout';
import { LoadingBanner } from 'shared/ui/loading-banner';

export const LeadInvoices = ({ leadId }: {leadId: number}) => {
  const { collection, isLoading } = useLeadInvoices(leadId);
  if (isLoading) return <LoadingBanner />;
  return (
    <>
      <Typography variant='body1' margin={1}>
    Счета, возможно связанные с лидом

      </Typography>

      <GridLayout
        noItemsText='Нет подходящих счетов'
        columns={['Номер', 'Статус' ]}
        items={collection}
        isLoading={isLoading}
        itemRender={(item: InvoiceInfoDto) => <Row item={item} />}
      />
    </>
  );
};

const Row = ({ item }: {item: InvoiceInfoDto}) => {
  return (<TableRow>
    <TableCell>
      <LinkToInvoice invoice={item} />
    </TableCell>
    <TableCell>
      <InvoiceStatusSpan status={item.status} size='small'/>
    </TableCell>
  </TableRow>);
};

